import { usePricingData } from "features/Pricing";
import { useDatadogInit } from "helpers/services/datadog";
import useAuthEventHandler from "hooks/useAuthEventHandler";
import useSignupCookies from "hooks/useSignupCookies";

/**
 * Component that initializes hooks that need to run within the Provider context
 */
const InitializeHooks = () => {
  // Initialize DataDog RUM with user context
  useDatadogInit();

  // Initialize auth event handling
  useAuthEventHandler();

  // Initialize signup cookie tracking
  useSignupCookies();

  // Initialize pricing data
  usePricingData();

  return null;
};

export default InitializeHooks;
